import { useId } from 'react';
import Select from 'react-select';
import { DropdownIndicator } from './selectComponents';
import { useSingleSelectValue } from './hooks';
import * as styles from './index.module.css';

export function SelectSingle({
  options = [],
  value = '',
  onChange,
  placeholder = 'Select...',
  isDisabled = false,
  isSearchable = true,
  isClearable = false,
}) {
  const instanceId = useId();
  const { selectedOption, handleChange } = useSingleSelectValue(options, value, onChange);

  return (
    <div className={styles['select-single']}>
      <Select
        instanceId={instanceId}
        options={options}
        value={selectedOption}
        onChange={handleChange}
        placeholder={placeholder}
        isDisabled={isDisabled}
        isSearchable={isSearchable}
        isClearable={isClearable}
        classNamePrefix="select-single"
        noOptionsMessage={() => 'No options found'}
        menuPortalTarget={document.body}
        menuPlacement="auto"
        components={{ DropdownIndicator }}
      />
    </div>
  );
}
